var lookupName = function lookupName(lookup) {
  return typeof lookup === "string" ? lookup : lookup.name;
};

export { lookupName };
